import { createRouter, createWebHistory } from 'vue-router'
import { errorsPage } from '@/modules/errors/route'
import { showToast as toast } from '@/helpers/UseToasts'
import { storeApp } from '@/store'
import { http } from '@/http'

// rotas
import { loginRoute } from '@/modules/auth/routes'
import { homeRoute } from '@/modules/home/routes'
import { extinguisherRoute } from '@/modules/extinguisher/routes'

const routes = [
  ...homeRoute,
  ...errorsPage,
  ...loginRoute,
  ...extinguisherRoute
]

const router = createRouter({
  history: createWebHistory('#'),
  routes
})

router.beforeEach(async (to, from, next) => {
  storeApp.state.loading = true

  if (to.name === 'logout') {

    localStorage.clear();
    storeApp.dispatch('hiddenMenuUserLoggedOut')
    storeApp.dispatch('setUserAuthenticated', false)

    toast(
      'Até logo!',
      'Deslogado com sucesso',
      'success'
    )

    next({ name: 'login' })
  }

  if (to.name !== 'login' && to.name !== 'logout') {
    try {
      await http.get(process.env.VUE_APP_API_URL.concat('me'))
      storeApp.state.loading = false
      next()
    } catch (error) {
      toast(
        'Aviso',
        'Sua sessão expirou',
        'error'
      )

      localStorage.clear();

      storeApp.dispatch('hiddenMenuUserLoggedOut')
      storeApp.dispatch('setUserAuthenticated', false)
      storeApp.state.loading = false

      next({ name: 'login' })
    }
  } else {
    storeApp.dispatch('setUserAuthenticated', false)
    storeApp.state.accessToken.clear()
    storeApp.state.loading = false
    next()
  }
})

export default router
